import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Input, Row, Switch, Table, Col, Popconfirm, InputNumber, Checkbox, Select } from 'antd';
import NewStyleInput from './NewStyleInput';
import Tooltip from '../../common/Tooltip';
import { useCallback, useState } from 'react';
import { useStore } from '../../../store/store';
import { ColorPaletteButton } from '../../common/ColorPaletteButton';
import LabelledRow from '../../common/LabelledRow';
import FieldGroupLabel from '../../common/boxStyleFields/FieldGroupLabel';
import DuotoneLightIcon from '../../common/DuotoneLightIcon';
import './tableConfig.css';
import { ItemTypes, borderIcons, collapseConfigPoint, defaultSelectorConfiguration, styleCheckbox } from '../../../constants/constants';
import TitleFontSelector from '../../common/TitleFontSelector';
import { useTranslation } from 'react-i18next';
import { maxFontSize, minFontSize } from '../../../constants/gridConfig';
import { TextStyleButtons } from '../../common/TitleConfiguration';
import { iconButtonStyle, mergeConfigurationSelectorStyles, navbarButtonStyle } from '../../../utils/styles';
import { NavbarListButton } from '../../Layout/NavbarListButton';
import CheckboxCustom from '../../common/CheckboxCustom';
import FontPicker from '../../common/FontPicker';
import { useSectionStylesFilter } from './utils';
import { useShareWithConfigPreview } from '../../../contexts/ConfigPreviewContext';
const selector = ({
  templates,
  configuration,
  setSelectedStyle,
  currentTemplate,
  createTemplateInStore,
  setConfiguration,
  postTemplate,
  styleRules,
  tmp
}) => ({
  selectorStyles: templates.filter((t) => t.pattern === 'style'),
  templates,
  configuration,
  setSelectedStyle,
  templatable: currentTemplate.templatable,
  createTemplateInStore,
  setConfiguration,
  postTemplate,
  styleRules,
  tmp
});

export const SelectorTabs = () => {
  const { configuration, setConfiguration, tmp } = useStore(selector);
  const [selectedStyle, setSelectedStyle] = useState(mergeConfigurationSelectorStyles(configuration, tmp)[0]);
  // Style montré sur la page d'aperçu du Drawer.
  useShareWithConfigPreview('selectorStyleId', selectedStyle?.id);
  const [isEditingStyleName, setIsEditingStyleName] = useState(false);
  const { t } = useTranslation();
  let styleList = [...mergeConfigurationSelectorStyles(configuration, tmp)];
  const { visibleStyles, filter: sectionStylesFilter } =
    useSectionStylesFilter(styleList);
  const styleData = [
    {
      title: 'Actions',
      dataIndex: 'actions',
      key: 'actions',
      width: (18 + 16) * 3 + 16,
    },
    {
      title: 'Style',
      dataIndex: 'style',
      key: 'style',
      onCell: (element, rowIndex) => {
        return {
          key: `style-config-${rowIndex}`,
          onClick: (event) => {
            handleSelectedStyle(element);
          },
        };
      },
    }
  ];

  const handleRemoveStyle = (idToRemove) => {
    const newselectorStyles = configuration.selectorStyles.filter(style => style.id !== idToRemove);
    setConfiguration({
      ...configuration.selectorStyles,
      selectorStyles: newselectorStyles,
    });
  };

  const handleRenameStyle = (ID, event) => {
    let styleToRename = {
      ...configuration.selectorStyles.find((element) => element.id === ID),
      name: event.target.value,
    };
    setConfiguration({
      selectorStyles: [
        ...configuration.selectorStyles.map((tableStyle) => {
          if (tableStyle.id === ID) {
            return styleToRename;
          }
          return tableStyle;
        }),
      ],
    });
    setIsEditingStyleName(null);
    setEditedName('');
    setSelectedStyle(styleToRename);
  };

  const handleCopyStyle = (copiedId) => {
    const copiedStyle = configuration.selectorStyles.find((s) => s.id === copiedId);
    let newStyle = {
      ...copiedStyle,
      id: configuration.selectorStylesIdCount + 1,
      name: `${copiedStyle.name} - Copie`,
    };
    let selectorStyles = [
      ...configuration.selectorStyles,
      newStyle,
    ];

    setConfiguration({
      ...configuration,
      selectorStyles,
      selectorStylesIdCount: configuration.selectorStylesIdCount + 1,
    });
  };

  const [editedName, setEditedName] = useState('');
  const dataSourceMapped = [];

  const iconStyle = {
    margin: '.5rem',
    fontSize: '1.5em',
  }
  visibleStyles.forEach((element) => {
    const cantEdit = element.id === 0 || element.fromTmp === true;
    const selectorStyleLocked = element.fromTmp === true;
    dataSourceMapped.push({
      key: `tableStyle-${element.id}`,
      id: element.id,
      style:
        isEditingStyleName === element.id ? (
          <Input
            value={editedName}
            id='styleNameInput2'
            style={{ width: '60%' }}
            onChange={(e) => setEditedName(e.target.value)}
            onPressEnter={(e) => {
              if (!cantEdit && e.target.value.length > 0) {
                handleRenameStyle(element.id, e);
              }
            }}
            onBlur={(e) => {
              if (!cantEdit && e.target.value.length > 0) {
                handleRenameStyle(element.id, e);
              }
            }}
          />
        ) : (
          element.name
        ),
      actions: (
        <div>
          <Tooltip
            placement='bottom'
            mouseLeaveDelay='0'
            title={'Renommer'}
          >
            <FontAwesomeIcon
              icon={icon({ name: 'edit', style: 'light' })}
              style={{
                ...iconStyle,
                color: cantEdit ? 'lightgray' : 'black',
              }}
              onClick={cantEdit ? null : (e) => {
                setIsEditingStyleName(element.id);
                setEditedName(element.name);
              }}
            />
          </Tooltip>
          <Tooltip
            placement='bottom'
            mouseLeaveDelay='0'
            title={'Dupliquer'}
          >
            <FontAwesomeIcon
              icon={icon({ name: 'copy', style: 'light' })}
              style={{
                ...iconStyle,
                color: selectorStyleLocked ? 'lightgray' : 'black',
              }}
              onClick={selectorStyleLocked ? null : (e) => handleCopyStyle(element.id)}
            />
          </Tooltip>
          <Tooltip
            placement='bottom'
            mouseLeaveDelay='0'
            title={'Supprimer'}
          >
            {cantEdit ? (
              <FontAwesomeIcon
                icon={icon({ name: 'trash', style: 'light' })}
                style={{
                  ...iconStyle,
                  color: 'lightgray'
                }}
              />
            ) : (
              <Popconfirm
                title='Voulez vous vraiment supprimer ce style ?'
                onConfirm={() => { handleRemoveStyle(element.id); }}
                okText='Oui'
                cancelText='Non'
              >
                <FontAwesomeIcon
                  icon={icon({ name: 'trash', style: 'light' })}
                  style={{
                    ...iconStyle,
                    color: 'red'
                  }}
                />
              </Popconfirm>
            )}
          </Tooltip>
        </div>
      ),
    });
  });

  const [isAddTableStyleLoading, setIsAddTableStyleLoading] = useState(false);

  const handleSelectedStyle = (e) => {
    mergeConfigurationSelectorStyles(configuration, tmp).forEach((element) => {
      if (element.id === e.id) {
        setSelectedStyle(element);
      }
    });
    return selectedStyle;
  };

  const loadingAnimation = () => {
    setIsAddTableStyleLoading(true);
    setTimeout(() => {
      setIsAddTableStyleLoading(false);
    }, 1000);
  };

  // const handleChange
  const handleSaveChanges = (updatedTableStyle) => {
    const updatedTableStyleIndex = configuration.selectorStyles.findIndex(
      (element) => element.id === updatedTableStyle.id
    );
    let newselectorStyles = [...configuration.selectorStyles];
    newselectorStyles[updatedTableStyleIndex] = updatedTableStyle;
    setSelectedStyle(updatedTableStyle);
    setConfiguration({
      ...configuration.selectorStyles,
      selectorStyles: newselectorStyles
    });
  };

  const handleAddTableStyle = (newStyleName) => {
    loadingAnimation();
    const newStyle = {
      ...defaultSelectorConfiguration,
      id: configuration.selectorStylesIdCount,
      name: newStyleName,
      fontFamily: configuration.fontFamily,
    };
    let selectorStyles = [
      ...configuration.selectorStyles,
      newStyle,
    ];
    setConfiguration({
      ...configuration,
      selectorStyles,
      selectorStylesIdCount: configuration.selectorStylesIdCount + 1,
    });
    setSelectedStyle({ ...newStyle });
  };

  const handleChangeFontSize = useCallback(() => (value) => {

    handleSaveChanges({
      ...selectedStyle,
      fontSize: value,
    });
  }, [handleSaveChanges, selectedStyle]);
  const handleChangeFontWeight = useCallback(() => () => {
    handleSaveChanges({
      ...selectedStyle,
      fontWeight: selectedStyle?.fontWeight ? '' : 'bold',
    });
  }, [handleSaveChanges, selectedStyle]);
  const handleChangeFontStyle = useCallback(() => () => {
    handleSaveChanges({
      ...selectedStyle,
      fontStyle: selectedStyle?.fontStyle ? '' : 'italic',
    });
  }, [handleSaveChanges, selectedStyle]);
  const handleChangeFontDecoration = useCallback(() => () => {
    handleSaveChanges({
      ...selectedStyle,
      textDecoration: selectedStyle?.textDecoration ? '' : 'underline',
    });
  }, [handleSaveChanges, selectedStyle]);

  const handleChangeStyleBox = useCallback(() => (value) => {
    handleSaveChanges({
      ...selectedStyle,
      styleBox: value,
    });
  }, [handleSaveChanges, selectedStyle]);

  const handleChangeColor = useCallback(() => (value) => {
    handleSaveChanges({
      ...selectedStyle,
      color: { "label": value, "style": configuration.colors.find((color) => color.label === value).style },
    });
  }, [handleSaveChanges, selectedStyle, configuration]);

  const handleChangeBackgroundColor = useCallback(() => (value) => {
    handleSaveChanges({
      ...selectedStyle,
      backgroundColor: { "label": value, "style": configuration.colors.find((color) => color.label === value).style },
    });
  }, [handleSaveChanges, selectedStyle, configuration]);

  const handleChangeSizeBox = useCallback(() => (value) => {
    handleSaveChanges({
      ...selectedStyle,
      box: {
        ...selectedStyle.box,
        width: value,
        height: value,
      }
    });
  }, [handleSaveChanges, selectedStyle, configuration]);

  const handleChangeDirectionLabel = useCallback(() => (value) => {
    handleSaveChanges({
      ...selectedStyle,
      box: {
        ...selectedStyle.box,
        direction: value.target.checked ? "rtl" : "ltr",
      }
    });
  }, [handleSaveChanges, selectedStyle, configuration]);

  const handleChangeBorderColor = useCallback(() => (value) => {
    handleSaveChanges({
      ...selectedStyle,
      borderColor: { "label": value, "style": configuration.colors.find((color) => color.label === value).style },
    });
  }, [handleSaveChanges, selectedStyle, configuration]);

  const handleChangeBorderSize = useCallback(() => (value) => {
    handleSaveChanges({
      ...selectedStyle,
      bordersSize: value,
    });
  }, [handleSaveChanges, selectedStyle, configuration]);

  const handleChangeBorderRadius = useCallback(() => (value) => {
    handleSaveChanges({
      ...selectedStyle,
      borderRadius: value,
    });
  }, [handleSaveChanges, selectedStyle, configuration]);

  const handleChangeColorCheck = useCallback(() => (value) => {
    handleSaveChanges({
      ...selectedStyle,
      check: {
        ...selectedStyle.check,
        ...{ color: { "label": value, "style": configuration.colors.find((color) => color.label === value).style } }
      },
    });
  }, [handleSaveChanges, selectedStyle, configuration]);

  const handleChangeSeparator = useCallback(() => (value) => {
    handleSaveChanges({
      ...selectedStyle,
      separator: value,
    });
  }, [handleSaveChanges, selectedStyle]);

  const handleChangeWidth = useCallback(() => (value) => {
    handleSaveChanges({
      ...selectedStyle,
      width: value,
    });
  }, [handleSaveChanges, selectedStyle]);

  const handleChangeBorderPlace = useCallback(() => (value) => {
    if (value === 'all') {
      handleSaveChanges({
        ...selectedStyle,
        borders: {
          ...selectedStyle.borders,
          top: true,
          bottom: true,
          left: true,
          right: true,
        },
      });
    } else {
      handleSaveChanges({
        ...selectedStyle,
        borders: {
          ...selectedStyle.borders,
          [value]: !selectedStyle.borders[value],
        },
      });
    }

  }, [handleSaveChanges, selectedStyle, configuration]);

  const handleChangePaddingTop = useCallback(() => (value) => {
    handleSaveChanges({
      ...selectedStyle,
      paddingTopBottom: value,
    });
  }, [handleSaveChanges, selectedStyle]);

  const handleChangeLeftRight = useCallback(() => (value) => {
    handleSaveChanges({
      ...selectedStyle,
      paddingLeftRight: value,
    });
  }, [handleSaveChanges, selectedStyle]);

  const handleChangePosition = useCallback(() => (value) => {
    handleSaveChanges({
      ...selectedStyle,
      position: value,
    });
  }, [handleSaveChanges, selectedStyle]);

  const handleChangeFontFamily = useCallback(() => (value) => {
    handleSaveChanges({
      ...selectedStyle,
      fontFamily: value,
    });
  }, [handleSaveChanges, selectedStyle]);

  const changeHandler = useCallback(() => ({
    borderRadius: handleChangeBorderRadius(),
    backgroundColor: handleChangeBackgroundColor(),
    borderSize: handleChangeBorderSize(),
    borderColor: handleChangeBorderColor(),
    color: handleChangeColor(),
    fontSize: handleChangeFontSize(),
    paddingLeftRight: handleChangeLeftRight(),
    paddingTop: handleChangePaddingTop(),
    position: handleChangePosition(),
    width: handleChangeWidth(),
    separator: handleChangeSeparator(),
    fontFamily: handleChangeFontFamily(),
    fontWeight: handleChangeFontWeight(),
    fontStyle: handleChangeFontStyle(),
    textDecoration: handleChangeFontDecoration(),
  }), [handleChangeBorderRadius, handleChangeBackgroundColor, handleChangeBorderSize, handleChangeBorderColor, handleChangeColor, handleChangeFontSize, handleChangeLeftRight, handleChangePaddingTop, handleChangePosition, handleChangeWidth, handleChangeSeparator, handleChangeFontFamily, handleChangeFontWeight, handleChangeFontStyle, handleChangeFontDecoration])



  return (
    <div style={{
      display: "flex",
      flexDirection: window.innerWidth <= collapseConfigPoint ? "column" : "row",
      width: "100%"
    }}>
      <div style={{ textAlign: 'center', width: window.innerWidth <= collapseConfigPoint ? "100%" : "40%" }}>
        <h5>Liste des styles des choix</h5>
        <NewStyleInput onAdd={handleAddTableStyle} loading={isAddTableStyleLoading} />
        {sectionStylesFilter}
        <Table
          columns={styleData}
          dataSource={dataSourceMapped}
          rowClassName={(record, _rowIndex) => { return record.style === selectedStyle.name ? 'tableSelectedRow' : '' }}
          pagination={false}
        />
      </div>
      <div style={{ display: "flex", flexDirection: "column", width: window.innerWidth <= collapseConfigPoint ? "100%" : "60%", margin: 20 }}>
        {/* Remonté à chaque changement de modèle : ces champs gardent leur
            valeur de départ, ils montreraient sinon celle du modèle d'avant. */}
        <div style={{ width: "100%" }} key={selectedStyle?.id}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 24 }}>
            <FieldGroupLabel>Affichage</FieldGroupLabel>
            <LabelledRow label="Couleur de fond">
              <ColorPaletteButton
                title="Couleur de fond"
                icon={<DuotoneLightIcon name='fill-drip' style={iconButtonStyle()} />}
                onChange={(e) => changeHandler().backgroundColor(e)}
                colors={configuration.colors}
                value={selectedStyle?.backgroundColor}
                disabled={selectedStyle?.fromTmp}
              />
            </LabelledRow>

            <LabelledRow label="Couleur des bordures">
              <ColorPaletteButton
                title="Couleur des bordures"
                icon={<DuotoneLightIcon name='border-outer' style={iconButtonStyle()} />}
                colorInIcon='primary'
                onChange={(e) => changeHandler().borderColor(e)}
                colors={configuration.colors}
                value={selectedStyle?.borderColor}
                disabled={selectedStyle?.fromTmp}
              />
            </LabelledRow>
            <LabelledRow label="Taille de la bordure">
              <InputNumber
                defaultValue={selectedStyle?.bordersSize}
                min={0}
                max={20}
                onChange={(e) => changeHandler().borderSize(e)}
                style={{ marginLeft: '5px' }}
                disabled={selectedStyle?.fromTmp}
              />
            </LabelledRow>
            <LabelledRow label="Radius de la bordure">
              <InputNumber
                defaultValue={selectedStyle?.borderRadius}
                min={0}
                max={20}
                onChange={(e) => changeHandler().borderRadius(e)}
                style={{ marginLeft: '5px' }}
                disabled={selectedStyle?.fromTmp}
              />
            </LabelledRow>
            <LabelledRow label="Marge hauteur">
              <InputNumber
                defaultValue={selectedStyle?.paddingTopBottom}
                min={0}
                max={40}
                onChange={(e) => changeHandler().paddingTop(e)}
                style={{ marginLeft: '5px' }}
                disabled={selectedStyle?.fromTmp}
              />
            </LabelledRow>
            <LabelledRow label="Marge latérale">
              <InputNumber
                defaultValue={selectedStyle?.paddinngLeftRight}
                min={0}
                max={40}
                onChange={(e) => changeHandler().paddingLeftRight(e)}
                style={{ marginLeft: '5px' }}
                disabled={selectedStyle?.fromTmp}
              />
            </LabelledRow>
            <LabelledRow label="Taille du choix dans les colonnes dessins">
              <div style={{ display: 'flex', alignItems: "center", gap: 5 }}>
                <InputNumber
                  defaultValue={selectedStyle?.width}
                  min={0}
                  max={800}
                  onChange={(e) => changeHandler().width(e)}
                  style={{ marginLeft: '5px' }}
                  disabled={selectedStyle?.fromTmp}
                />
              </div>
            </LabelledRow>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 24 }}>
            <FieldGroupLabel>Texte</FieldGroupLabel>
            <LabelledRow label='Couleur du texte'>
              <ColorPaletteButton
                title='Couleur du texte'
                onChange={(e) => changeHandler().color(e)}
                disabled={selectedStyle.id === 0 || selectedStyle?.fromTmp}
                colors={configuration.colors}
                value={selectedStyle.id === 0 ? configuration.baseFontColor : selectedStyle?.color}
              />
            </LabelledRow>
            <LabelledRow label="Police des labels">
              <FontPicker
                disabled={selectedStyle.id === 0 || selectedStyle?.fromTmp}
                forcedValue={selectedStyle.id === 0 ? configuration.fontFamily : selectedStyle?.fontFamily}
                onChange={(e) => changeHandler().fontFamily(e)} />
            </LabelledRow>
            <LabelledRow label={t('font-size')}>
              <InputNumber
                min={minFontSize}
                max={maxFontSize}
                disabled={selectedStyle.id === 0 || selectedStyle?.fromTmp}
                defaultValue={selectedStyle.id === 0 ? configuration.fontSize : selectedStyle?.fontSize}
                onChange={(e) => changeHandler().fontSize(e)}
                style={{ marginLeft: '5px' }}
              />
            </LabelledRow>
            <LabelledRow label='Style du texte'>
              <TextStyleButtons
                rules={selectedStyle}
                changeHandler={changeHandler()}
                disabled={selectedStyle?.fromTmp}
              />
            </LabelledRow>
            <LabelledRow label="Position du texte">
              <Select
                options={[{ value: "start", label: 'Gauche' }, { value: "center", label: 'Centre' }, { value: "end", label: 'Droite' }]}
                onChange={(e) => changeHandler().position(e)}
                defaultValue={selectedStyle?.position}
                disabled={selectedStyle?.fromTmp}
              ></Select>
            </LabelledRow>
            <LabelledRow label="Séparateur si choix multiple">
              <Select
                options={[{ value: "\n", label: 'Saut de ligne' }, { value: " ", label: 'Espace' }, { value: "|", label: '|' }, { value: ";", label: ';' }, { value: ",", label: ',' }, { value: ":", label: ':' }, { value: ".", label: '.' }, { value: "-", label: '-' }]}
                onChange={(e) => changeHandler().separator(e)}
                defaultValue={selectedStyle?.separator}
                disabled={selectedStyle?.fromTmp}
                style={{
                  minWidth: 126
                }}
              ></Select>
            </LabelledRow>
          </div>
        </div>

      </div>
    </div>
  );
};
export default SelectorTabs;
